import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from '../../services/authService';
import Button from '../../components/common/Button/Button';
import cosmicLogo from '../../assets/images/cosmic-logo.png';
import styles from './Login.module.css';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      await resetPassword(token, password);
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginCard}>
        <div className={styles.header}>
          <img src={cosmicLogo} alt="COSMIC Logo" className={styles.logoImage} />
          <h1 className={styles.logo}>COSMIC</h1>
          <p className={styles.subtitle}>Choose a new password</p>
        </div>

        {!token ? (
          <div className={styles.form}>
            <div className={styles.error}>
              This password reset link is missing its token. Please use the button in the
              email exactly as it was sent, or request a new link.
            </div>
            <Link to="/forgot-password" style={{ color: '#4a90e2', display: 'block', textAlign: 'center', marginTop: '12px' }}>
              Request a new link
            </Link>
          </div>
        ) : done ? (
          <div className={styles.form}>
            <p style={{ textAlign: 'center', color: '#2e7d32', fontSize: '14px', lineHeight: 1.6 }}>
              Your password has been reset. Taking you to the login page...
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.formGroup}>
              <label htmlFor="password" className={styles.label}>New Password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={styles.input}
                placeholder="Enter your new password"
                required
              />
              <small style={{ color: '#666', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                At least 8 characters, with an uppercase and a lowercase letter, a number
                and a special character.
              </small>
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="confirmPassword" className={styles.label}>Confirm New Password</label>
              <input
                id="confirmPassword"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className={styles.input}
                placeholder="Re-enter your new password"
                required
              />
            </div>

            {error && <div className={styles.error}>{error}</div>}

            <Button type="submit" variant="primary" fullWidth loading={loading} disabled={loading}>
              {loading ? 'Resetting...' : 'Reset Password'}
            </Button>
          </form>
        )}

        <div className={styles.footer}>
          <p>
            <Link to="/login" style={{ color: '#4a90e2' }}>Back to login</Link>
          </p>
          <p style={{ marginTop: '10px' }}>© 2025 CreatED. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
